// Tunables for the domain-composition layer. No magic numbers inline (iron rule 3).

/** Default toast auto-dismiss hint (ms) handed to the app notifier; the app owns rendering. */
export const NOTIFY_TTL_MS = 5_000;

/**
 * Reserved home for feature flags (03-03 §2.5 / EPIC 1). Nothing is built now — this
 * constant only reserves the TTL so `useFeatureFlag` lands here, not ad-hoc in apps.
 */
export const FLAG_TTL_MS = 60_000;
